import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
// change BrowserRouter to HashRouter to build and use for local downloads as zip
// import {
//   HashRouter as Router,
//   Route,
//   Routes,
//   Navigate,
// } from "react-router-dom";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  Outlet
} from "react-router-dom";

import { MainLayout } from "./Layouts/MainLayout";
import { MarketSector, Home, Product } from "./pages";

import "./App.scss";
import packageJson from "../package.json";
import { fetchDeviceListAsync, resetConfigurator } from "reduxStore/slices/configuratorSlice";
import { Technology } from "pages/Technology";
import { PasswordDialog } from "shared/components/PasswordDialog";
import AdminPanel from "./AdminPanel";
import { useSelector } from 'react-redux';
import AdminRoute from "./AdminPanel/AdminRoute";
import ResetPasswordForm from "./shared/components/ResetPasswordForm";
import { fetchCompaniesListAsync } from "./reduxStore/slices/companySlice";
import { isOfflineMode } from "./utils/checkOfflineMode";


function App() {
  const { version } = packageJson;
  const dispatch = useDispatch();

  useEffect(() => {
    const storedVersion = localStorage.getItem("appVersion");

    if (storedVersion !== version) {
      dispatch(resetConfigurator());
      if (isOfflineMode()) {
        const currentVersion = version;

        // Clear all localStorage
        localStorage.clear();

        // Restore the version after clearing
        localStorage.setItem("appVersion", currentVersion);
      } else {
        // Just update version in online mode
        localStorage.setItem("appVersion", version);
      }
    }

    dispatch(fetchDeviceListAsync());
    dispatch(fetchCompaniesListAsync());
  }, [dispatch, version]);

  const PrivateRoute = () => {
    const token = useSelector(state => state.authReducer.token);
    return token ? <Outlet /> : <Navigate to="/login" />;
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={
          <PasswordDialog
            version={version}
            onVersionMismatch={() => dispatch(resetConfigurator())}
          />
        } />
        <Route path="/reset-password/:token" element={<ResetPasswordForm />} />
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<Navigate to="/general" replace />} />
          <Route path="/:company?" element={<Home />} />
          <Route path="/" element={<MainLayout />}>
            <Route path=":company/market" element={<MarketSector />} />
            <Route path=":company/product" element={<Product />} />
            <Route path=":company/enhancements" element={<Technology />} />
            <Route path=":company/technology" element={<Technology />} />
          </Route>
          <Route path="*" element={<Navigate to="/general" replace />} />
        </Route>
        <Route element={<AdminRoute />}>
          <Route path="/admin" element={<AdminPanel />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
